<template>
  <!-- 个性化定制需求 -->
  <div class="demandCustomizationComponent">
      <p>{{summary}}</p>
      <ul>
          <li><el-input v-model="fromData.name" placeholder="姓名（必填）"></el-input></li>
          <li><el-input v-model="fromData.companyName" placeholder="公司名称（必填）"></el-input></li>
      </ul>
      <ul>
          <li><el-input style="height: 36px;" v-model="fromData.position" placeholder="职位（必填）"></el-input></li>
          <li><el-input v-model="fromData.mobileNumberEmail" placeholder="联系方式手机号/邮箱（必填）"></el-input></li>
      </ul>
      <div class="footerBtnbox">
          <button class="button_main" @click="sumbileClick">立即提交</button>
      </div>
  </div>
</template>

<script>
import { homePageCollectMsg } from "@/api/lxc"
export default {
  props: {
    summary: {
      type: String,
      default: ''
    }
  },
  name: 'home',
  data () {
    return {
      fromData:{
          name:"",
          companyName:"",
          position:"",
          mobileNumberEmail:""
      }
    }
  },
  methods:{
    async sumbileClick(){
      let verificationMobile=new RegExp(/^1[3456789]\d{9}$/);
      let verificationEmail=new RegExp(/^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/);
      if(!this.fromData.name){
        this.$message.warning("请输入姓名")
        return false
      }
      if(!this.fromData.companyName){
        this.$message.warning("请输入公司名称")
        return false
      }
      if(!this.fromData.position){
        this.$message.warning("请输入职位")
        return false
      }
      if(!this.fromData.mobileNumberEmail){
        this.$message.warning("请输入手机号或邮箱")
        return false
      }else{
        if(!verificationMobile.test(this.fromData.mobileNumberEmail) && !verificationEmail.test(this.fromData.mobileNumberEmail)){
          this.$message.warning("请输入正确的手机号或邮箱")
          return false
        }
      }
      try{
        const data=await homePageCollectMsg({
          mobile:this.fromData.mobileNumberEmail,
          name:this.fromData.name,
          company:this.fromData.companyName,
          job:this.fromData.position,
          type:"1"
        })
        this.$message.success("提交成功")
        this.fromData={
            name:"",
            companyName:"",
            position:"",
            mobileNumberEmail:""
        }
      }catch(err){
        this.$message.warning(err.message)
      }
    }
  }
}
</script>

<style scoped lang="less">
.demandCustomizationComponent{
    padding-bottom: 60px;
    p{
        width: 720px;
        text-align: center;
        font-size: 24px;
        // font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(51,51,51,1);
        line-height:40px;
        padding: 20px 0 60px 0;
        margin: 0 auto;
    }
    ul{
        display: flex;
        justify-content: space-between;
        width: 460px;
        padding-bottom: 34px;
        margin: auto;
        li:nth-child(1){
           width: 120px;
        }
        li:nth-child(2){
            width: 320px;
        }
    }
    ul:nth-child(2){
        padding-bottom:20px;
    }
    .footerBtnbox{
        width: 460px;
        margin: auto;
    }
    .button_main {
        height: 44px;
    }
    .button_main:hover {
      background: #214DA6;
      border-color: #214DA6;
    }
}
</style>

<style>
    .demandCustomizationComponent .el-input__inner {
        height: 36px;
        line-height: 36px;
    }
</style>




// WEBPACK FOOTER //
// src/page/home/homeComponents/demandCustomization.vue